import { PaymentsTab } from "@/components/settings/PaymentsTab";

export default function PaymentsSettings() {
  return (
    <div className="space-y-6" data-cy="payments-settings-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Contas Bancárias</h1>
        <p className="text-muted-foreground">
          Gerencie suas contas bancárias e métodos de pagamento
        </p>
      </div>
      <PaymentsTab />
    </div>
  );
}

